import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import EmailIcon from '@mui/icons-material/Email';

export function Help() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <h1 className="font-outfit text-3xl font-semibold mb-8 flex items-center gap-3 text-pearl-white relative after:absolute after:bottom-0 after:left-0 after:w-24 after:h-px after:bg-gradient-to-r after:from-naia-pink after:to-transparent">
        <span>Help & FAQ</span>
      </h1>

      <div className="space-y-8">
        {/* Getting Started */}
        <section className="bg-white/5 rounded-xl p-6">
          <h2 className="text-xl font-outfit font-semibold mb-4 flex items-center gap-2 text-pearl-white">
            <InfoIcon />
            <span>Getting Started</span>
          </h2>
          <div className="space-y-4 text-slate-grey">
            <div>
              <h3 className="text-lg text-pearl-white mb-2">What is Naia?</h3>
              <p>
                Naia is a streaming service created for and by vocalsynth fans. We provide a platform
                for discovering and enjoying music created with vocalsynths, with a focus on high-quality
                playback and a seamless listening experience.
              </p>
            </div>
            <div>
              <h3 className="text-lg text-pearl-white mb-2">How do I use Naia?</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Browse songs on the Home page or Songs page</li>
                <li>Explore our curated Collections for themed sets of songs</li>
                <li>Click on artist names to discover more of their music</li>
                <li>Use the heart icon to favorite songs for quick access</li>
                <li>Click on voicebank names to find similar songs</li>
              </ul>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white/5 rounded-xl p-6">
          <h2 className="text-xl font-outfit font-semibold mb-4 flex items-center gap-2 text-pearl-white">
            <QuestionAnswerIcon />
            <span>Frequently Asked Questions</span>
          </h2>
          <div className="space-y-6 text-slate-grey">
            <div>
              <h3 className="text-lg text-pearl-white mb-2">What audio quality does Naia use?</h3>
              <p>
                While exact quality and bitrate varies from song to song, Naia aims to
                provide at minimum 16-bit WAV-format audio.
              </p>
            </div>
            <div>
              <h3 className="text-lg text-pearl-white mb-2">Can I download songs for offline listening?</h3>
              <p>
                Currently, Naia is a streaming-only service. We're exploring options for offline
                playback in future updates.
              </p>
            </div>
            <div>
              <h3 className="text-lg text-pearl-white mb-2">How do I report issues or suggest features?</h3>
              <p>
                We value your feedback! You can report issues or suggest features by contacting
                our support.
              </p>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="bg-white/5 rounded-xl p-6">
          <h2 className="text-xl font-outfit font-semibold mb-4 flex items-center gap-2 text-pearl-white">
            <EmailIcon />
            <span>Contact Us</span>
          </h2>
          <div className="text-slate-grey">
            <p>
              (this is a placeholder)you may not contact us{' '}
              <a href="mailto:support@naia.app" className="text-naia-pink hover:text-soft-violet">
                ever.
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
} 